import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";

/**
 * This utility is used to return where to show the address details to user (if we have to show it)
 * @param param0 listingType - type of the main listing
 * @param param1 showInternationalInputFields - check if the creator 'or' the user is international
 * @param param2 isMerchandiseOrderBumpSelected - check if there are merchandise and an merchandise order bump is selected
 * @returns object - containing two keys
 - showAddressInsideUserDetails - to show the address details inside the user details form group
 - showAddressOutsideUserDetails - to show the address details outside the user details form group
 */
export const getShowAddressFields = ({
    listingType,
    showInternationalInputFields,
    isMerchandiseOrderBumpSelected = false,
}: {
    listingType: number;
    showInternationalInputFields: boolean;
    isMerchandiseOrderBumpSelected?: boolean;
}) => {
    const isListingMerchandise = listingType === LISTING_TYPES.MERCHANDISE;

    /**
     * The address details, part of user details are shown to international creator users 'or' international
     * users 'or' if the main listing is of merchandise type
     */
    const showAddressInsideUserDetails =
        isListingMerchandise || showInternationalInputFields;

    /**
     * We show delivery details to the user if its not an international creator or international
     * user 'and' the main listing is not of Merchandise type 'and' an order bump of merchandise type is selected by the user
     */
    const showAddressOutsideUserDetails =
        !showAddressInsideUserDetails && isMerchandiseOrderBumpSelected;

    return {
        showAddressInsideUserDetails,
        showAddressOutsideUserDetails,
    };
};
